export default __webpack_public_path__ + "static/media/ExploreTheDeep_07.277a6543.png";